import React, {Component} from 'react';
import {connect} from "react-redux";
import * as actions from "../../../../../../actions";
import Loading from "react-loading-animation";
import api from "../../../../../../util/clipstore/user/api";
import {Col, TabPane} from "reactstrap";
import * as _ from "lodash";
import InfiniteScroll from "react-infinite-scroll-component";
import HomeCardComponent from "../../../../../../components/clipstore/user/home/card";

class AttachmentPublishedContentTab extends Component {

    constructor() {
        super();
        this.state = {
            pricingType: 'all',
            contentType: 'all',
            sortBy: 'new',
            currentPage: 1,
            totalPages: 1,
            currentItems: 12,
            totalItems: 12,
            reset: false,
            hasMore: true,
            content: {},
            contentList: [],
        }
    }

    componentDidMount() {
        let broadcasterID = this.props.broadcaster.id;
        this.setState({
            broadcasterID
        }, () => {
            api.getContentListAPI(this.props, this.state.pricingType, this.state.contentType, this.state.sortBy, this.state.currentPage, broadcasterID)
        });
    }

    loadNextPage = () => {
        let currentPage = this.state.currentPage;
        currentPage = currentPage + 1;

        this.setState({
            currentPage
        }, () => {
            api.getContentListAPI(this.props, this.state.pricingType, this.state.contentType, this.state.sortBy, this.state.currentPage, this.state.broadcasterID)
        })
    }

    UNSAFE_componentWillReceiveProps(nextProps) {

        //this will be called for every pagination we perform
        if (nextProps.get_content_list && nextProps.get_content_list.payload !== this.props.get_content_list.payload) {

            if (nextProps.get_content_list.payload &&
                nextProps.get_content_list.payload.hasOwnProperty("data") &&
                nextProps.get_content_list.payload.data.hasOwnProperty("data")) {

                let data = nextProps.get_content_list.payload.data;
                let contentList = data.data;

                if (this.state.currentPage !== 1) {
                    if (contentList.length > 0) {
                        contentList = this.state.contentList.concat(nextProps.get_content_list.payload.data.data)
                    } else {
                        contentList = this.state.contentList;
                    }
                }

                //fast switching causes to show duplicates
                contentList = _.uniqBy(contentList, function (e) {
                    return e.id;
                });

                this.setState({
                    currentPage: parseInt(data.current_page),
                    hasMore: parseInt(data.current_page) <= parseInt(data.last_page),
                    totalPages: parseInt(data.last_page),
                    currentItems: parseInt(data.current_page) * data.data.length,
                    totalItems: parseInt(data.total),
                    contentList,
                    reset: false
                }, () => {
                    console.log("contentList", this.state.contentList)
                    if (this.state.hasMore && this.state.currentPage < 3) {
                        this.loadNextPage();
                    }
                })
            }
        }
    }

    render() {
        return (
            <TabPane tabId="published-content">
                <Col sm="12" className="bg-white p-3 rounded">
                    <InfiniteScroll
                        height={420}
                        dataLength={this.state.contentList.length}
                        next={this.loadNextPage}
                        hasMore={this.state.hasMore}
                        loader={<Loading/>}
                        endMessage={<span/>}
                    >

                        {
                            this.state.contentList.map((content, index) => {
                                return (
                                    <HomeCardComponent
                                        openBroadcasterProfile={() => {
                                        }}
                                        showBroadcasterSection={false}
                                        isCheckBox
                                        selectedItems={this.props.selectedItems}
                                        selectCard={(content) => {
                                            console.log("selectCard", content)
                                            this.props.setSelectedItem(content);
                                        }}
                                        openDetail={() => {
                                        }}
                                        content={content}
                                        key={`published-content-component-${index}`}
                                    />
                                )
                            })
                        }
                    </InfiniteScroll>
                </Col>

            </TabPane>
        );
    }
}

AttachmentPublishedContentTab.propTypes = {};

function mapStateToProps(state, ownParams) {
    return {
        device: state.device.payload,
        get_content_list: state.get_content_list,
    };
}

export default connect(mapStateToProps, actions)(AttachmentPublishedContentTab);
